import { useState, useEffect, useRef } from 'react';

/** Vertical subform tab id for HCP License Information */
export const CUSTOM_HCP_LICENSES_LIST_TAB_ID = 'custom_hcp_licenses_list';

/**
 * @param {Array} items tab items (`id` or `value`)
 * @param {*} defaultValue initial selection
 * @param {{ preferHcpLicenseTab?: boolean }} [options] when true, selects License Information once it exists in `items`
 */
export const useActiveTab = (items, defaultValue = null, options = null) => {
  const preferHcpLicenseTab = options?.preferHcpLicenseTab === true;
  const hcpDefaultAppliedRef = useRef(false);

  const [activeTab, setActiveTab] = useState(defaultValue);

  useEffect(() => {
    if (!items?.length) return;

    const hasLicenseTab = items.some(
      (i) => i.id === CUSTOM_HCP_LICENSES_LIST_TAB_ID
    );

    setActiveTab((prev) => {
      if (
        preferHcpLicenseTab &&
        hasLicenseTab &&
        !hcpDefaultAppliedRef.current
      ) {
        hcpDefaultAppliedRef.current = true;
        return CUSTOM_HCP_LICENSES_LIST_TAB_ID;
      }
      return prev ?? (items[0].id || 0);
    });
  }, [items, preferHcpLicenseTab]);

  return [activeTab, setActiveTab];
};
